import React, { useEffect, useState, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import TableContainer from './TableContainer';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Header from './Header';
import TopRight from './TopRight';
import Cookies from 'js-cookie';

var CryptoJS = require("crypto-js");

function SuperAdmin() {

  // eslint-disable-next-line
  const [apiError, setApiError] = useState(false);
  const [apiFetched, setApiFetched] = useState(false);
  const [data, setData] = useState([]);

  const navigate = useNavigate();

  useEffect(() => {
    // Fetch Data
    const doFetch = async () => {
      // const response = await fetch('https://randomuser.me/api/?results=100');
      // const body = await response.json();
      // const contacts = body.results;
      const contacts = [
        {
          "id": 1,
          "full_name": "Faraz Mansoori 1",
          "email": "faraz@xaprio.com1",
          "company": "Xapads 2",
          "google_id": "Google Id 1",
          "aniview_id": "Aniview 1",
          "adkernel_id": "Adkernel 1",
        },
        {
          "id": 2,
          "full_name": "Faraz Mansoori 2",
          "email": "faraz@xaprio.com2",
          "company": "Xapads 1",
          "google_id": "Google Id 2",
          "aniview_id": "Aniview 2",
          "adkernel_id": "Adkernel 2",
        },
        {
          "id": 3,
          "full_name": "Faraz Mansoori 3",
          "email": "faraz@xaprio.com3",
          "company": "Xapads 4",
          "google_id": "Google Id 3",
          "aniview_id": "Aniview 3",
          "adkernel_id": "Adkernel 3",
        },
        {
          "id": 4,
          "full_name": "Faraz Mansoori 4",
          "email": "faraz@xaprio.com4",
          "company": "Xapads 3",
          "google_id": "Google Id 4",
          "aniview_id": "Aniview 4",
          "adkernel_id": "Adkernel 4",
        },
        {
          "id": 5,
          "full_name": "Faraz Mansoori 5",
          "email": "faraz@xaprio.com5",
          "company": "Xapads 5",
          "google_id": "Google Id 5",
          "aniview_id": "Aniview 5",
          "adkernel_id": "Adkernel 5",
        },
        {
          "id": 6,
          "full_name": "Faraz Mansoori 6",
          "email": "faraz@xaprio.com6",
          "company": "Xapads 11",
          "google_id": "Google Id 6",
          "aniview_id": "Aniview 6",
          "adkernel_id": "Adkernel 6",
        },
        {
          "id": 7,
          "full_name": "Faraz Mansoori 7",
          "email": "faraz@xaprio.com7",
          "company": "Xapads 9",
          "google_id": "Google Id 7",
          "aniview_id": "Aniview 7",
          "adkernel_id": "Adkernel 7",
        },
        {
          "id": 8,
          "full_name": "Faraz Mansoori 8",
          "email": "faraz@xaprio.com8",
          "company": "Xapads 8",
          "google_id": "Google Id 8",
          "aniview_id": "Aniview 8",
          "adkernel_id": "Adkernel 8",
        },
        {
          "id": 9,
          "full_name": "Faraz Mansoori 9",
          "email": "faraz@xaprio.com9",
          "company": "Xapads 7",
          "google_id": "Google Id 9",
          "aniview_id": "Aniview 9",
          "adkernel_id": "Adkernel 9",
        },
        {
          "id": 10,
          "full_name": "Faraz Mansoori 10",
          "email": "faraz@xaprio.com10",
          "company": "Xapads 10",
          "google_id": "Google Id 10",
          "aniview_id": "Aniview 10",
          "adkernel_id": "Adkernel 10",
        },
        {
          "id": 11,
          "full_name": "Faraz Mansoori 11",
          "email": "faraz@xaprio.com11",
          "company": "Xapads 6",
          "google_id": "Google Id 11",
          "aniview_id": "Aniview 11",
          "adkernel_id": "Adkernel 11",
        },
      ]
      // console.log(contacts);
      setTimeout(function(){
        setData(contacts);
        setApiFetched(true);
      }, 600);
    };
    doFetch();
  }, []);


  const columns = useMemo(
    () => [
      {
        Header: 'ID',
        Footer: '',
        accessor: 'id',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Name',
        // Footer: 'ID',
        accessor: 'full_name',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Email',
        // Footer: 'ID',
        accessor: 'email',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Company',
        // Footer: 'ID',
        accessor: 'company',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Google Id',
        // Footer: 'ID',
        accessor: 'google_id',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Aniview Id',
        // Footer: 'ID',
        accessor: 'aniview_id',
        disableSortBy: false,
        disableFilters: true,
      },
      {
        Header: 'Adkernel Id',
        // Footer: 'ID',
        accessor: 'adkernel_id',
        disableSortBy: false,
        disableFilters: true,
      },
    ],
    []
  );  
  if(Cookies.get('status')) {
    if (JSON.parse(CryptoJS.AES.decrypt(Cookies.get('user'), 'XJ3ou%#1').toString(CryptoJS.enc.Utf8)).user_type==='sa') {
      return (

        <div>
          <div>
            <div className="d-flex w-100 bg_light">
              <Header />
              <div className="w-100 p-24px">
                <div className="row">
                  <div className="col-md-6">
                    <div className="d-flex mb-28px align-items-center">
                      <div className="header_content">
                        <h1 className="nav_heading">Admin</h1>
                      </div>
                      
                    </div>
                  </div>
                  <div className="col-md-6">
                    <TopRight page="admin" />
                  </div>
                </div>
                <div className="row">
                  <div className='col-md-12'>
                    <div className='card_content_data'>
                      <TableContainer
                        columns={columns}
                        data={data}
                        apiError={apiError}
                        pageServing="admin"
                        defaultSortedColumn='id'
                        apiFetch={apiFetched}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      );
    } else {
      navigate("/dashboard");
    }
  } else {
    window.location.href = "/";
  }

}

export default SuperAdmin;